import React from 'react'

const Background = ({ children }) => {
    return <div className='bg-white h-full'>{children}</div>
}

export default Background
